import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import {
    TActionType,
    TransactionType,
} from '../../Utility/Tracking/DataSet/Transaction';
import { sendEvent } from '../../Utility/Tracking/Track';
import { TransactionTrackingEventName } from '../../Utility/Tracking/TrackingEvent';
import { trackTransaction } from '../../Utility/Tracking/TrackingHelpers/Transaction';
import GameStateHelper from '../Game/GameStateHelper';
import { IGameState } from '../Game/IGameState';
import { spendCoins } from '../Player/PlayerInventoryHelper';
import { getLevelStarsTotal } from '../Player/PlayerLevelHelper';
import { unlockNextWorld } from '../Player/PlayerStateHelper';
import { showPopup, noCoinsPopupID } from '../UI/UIStateHelper';
import { WorldActions } from './WorldActions';
import { gameTracking } from '../../Utility/Tracking/FBLegacyTracking';
import { ASOLIWorldEvents } from '../../Constants/Tracking';

/**
 * The 6 includes each friend ID *AND* their avatar...
 */
export const REQUIRED_GATE_FRIENDS_LENGTH = 6;

export const WorldReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof WorldActions>
): IGameState => {
    switch (action.type) {
        case getType(WorldActions.OPEN_GATE_COINS):
            if (state.playerState.coins >= 1000) {
                let playerState = spendCoins(state.playerState, 1000);
                state = {
                    ...state,
                    playerState: unlockNextWorld(playerState),
                };
                trackTransaction(
                    state,
                    TransactionType.COIN_PURCHASE,
                    TActionType.GATE
                );
                gameTracking(ASOLIWorldEvents[state.playerState.world]);
                // Instantly load into next world.
                return GameStateHelper.loadWorld(
                    state,
                    state.playerState.world
                );
            }
            return {
                ...state,
                UIState: showPopup(state.UIState, noCoinsPopupID(), {}),
            };
        case getType(WorldActions.OPEN_GATE_FRIENDS):
            if (
                state.playerState.gateFriends.length >=
                REQUIRED_GATE_FRIENDS_LENGTH
            ) {
                state = {
                    ...state,
                    playerState: unlockNextWorld(state.playerState),
                };
                gameTracking(ASOLIWorldEvents[state.playerState.world]);
                // Instantly load into next world.
                return GameStateHelper.loadWorld(
                    state,
                    state.playerState.world
                );
            }
            break;
        case getType(WorldActions.OPEN_GATE_STARS):
            // Check if player has enough stars. Payload is the number of required stars to unlock the next world.
            if (getLevelStarsTotal(state.playerState) >= action.payload) {
                state = {
                    ...state,
                    playerState: unlockNextWorld(state.playerState),
                };
                gameTracking(ASOLIWorldEvents[state.playerState.world]);
                // Instantly load into next world.
                return GameStateHelper.loadWorld(
                    state,
                    state.playerState.world
                );
            }
            break;
    }

    return state;
};
